import { render, staticRenderFns } from "./DatePickerComponent3.vue?vue&type=template&id=ecf82590&"
import script from "./DatePickerComponent3.vue?vue&type=script&lang=js&"
export * from "./DatePickerComponent3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports